import React from 'react'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { useLocation, Link } from 'react-router-dom';
import {AppBar, LinearProgress} from '@mui/material';
import OwlCarousel from "react-owl-carousel";
import {loadCss} from '../../common/helper.js'
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";


if (process.env.NODE_ENV === 'development'){
	require('../../mock/index')
}


function HotelItem(props){

  // console.log('hotel item', props)
  return(
    <div className="hotels-item bg-white shadow-md rounded p-3">
    <div className="row">
      <div className="col-md-4">
      {/*飯店輪播圖片 開始*/}
      <OwlCarousel className="owl-theme" items={1} loop nav dots={false}>
        {props.Images.length == 0  ?  (<div className="item">
        <a href="#">
        <img className="img-fluid" src="Flight-Hotel/panelAirR/images/hotel-default.jpg" alt="hotel default" />
        </a>
        </div>) :     (
        props.Images.map((item, index)=> {
          return <div key={index} className="item">
          <a href="#">
          <img className="img-fluid" src={item.Link} alt={item.Description} />
          </a>
          </div>
        })
)
        }
      </OwlCarousel>
      
        {/* <div className="owl-carousel owl-theme single-slider owl-loaded owl-drag" data-animateout="fadeOut" data-animatein="fadeIn" data-autoplay data-loop="true" data-autoheight="true" data-nav="true" data-items={1}>
        <div className="owl-stage-outer owl-height" style={{height: '167.962px'}}><div className="owl-stage" style={{transform: 'translate3d(-488px, 0px, 0px)', transition: 'all 0s ease 0s', width: '1955px'}}><div className="owl-item cloned" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-3.jpg" alt="hotels 3" /></a></div></div><div className="owl-item cloned" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-4.jpg" alt="hotels 4" /></a></div></div><div className="owl-item active" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-1.jpg" alt="hotels 1" /></a></div></div><div className="owl-item" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-2.jpg" alt="hotels 2" /></a></div></div><div className="owl-item" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-3.jpg" alt="hotels 3" /></a></div></div><div className="owl-item" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-4.jpg" alt="hotels 4" /></a></div></div><div className="owl-item cloned" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-1.jpg" alt="hotels 1" /></a></div></div><div className="owl-item cloned" style={{width: '244.325px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-2.jpg" alt="hotels 2" /></a></div></div></div></div><div className="owl-nav"><button type="button" role="presentation" className="owl-prev"><i className="fa fa-chevron-left" /></button><button type="button" role="presentation" className="owl-next"><i className="fa fa-chevron-right" /></button></div><div className="owl-dots"><button role="button" className="owl-dot active"><span /></button><button role="button" className="owl-dot"><span /></button><button role="button" className="owl-dot"><span /></button><button role="button" className="owl-dot"><span /></button></div></div>  */}
      </div>
      {/*飯店輪播圖片 結束*/}
      <div className="col-md-8 pl-3 pl-md-0 mt-3 mt-md-0">
        <div className="row no-gutters">
          <div className="col-sm-9">
            <h4><a href="#" className="text-dark text-5">{props.HotelName}</a></h4>
            <p className="mb-2">
              <span className="mr-2">
            {props.StarRating && Array.from(new Array(parseInt(props.StarRating)), (v, i) => i).map((item)=>{return <i key={item} className="fas fa-star text-warning" />})}
              </span>
              <span className="text-black-50"><i className="fas fa-map-marker-alt" /> {props.HotelAddress}</span>
            </p>
            <p className="hotels-amenities d-flex align-items-center mb-2 text-3">
              <span data-toggle="tooltip" data-original-title="Internet/Wi-Fi"><i className="fas fa-wifi" /></span>
              <span data-toggle="tooltip" data-original-title="Restaurant"><i className="fas fa-utensils" /></span>
              <span data-toggle="tooltip" data-original-title="Bar"><i className="fas fa-glass-martini" /></span>
              <span data-toggle="tooltip" data-original-title="Swimming Pool"><i className="fas fa-swimmer" /></span>
              <span data-toggle="tooltip" data-original-title="Business Facilities"><i className="fas fa-chalkboard-teacher" /></span>
              <span data-toggle="tooltip" data-original-title="Spa"><i className="fas fa-spa" /></span>
              <span data-toggle="tooltip" data-original-title="Gym"><i className="fas fa-dumbbell" /></span>
            </p>
            <p className="reviews mb-2" style={{marginTop: '32px'}}>
              <span className="reviews-score px-2 py-1 rounded font-weight-600 text-light">
                <i className="fa fa-plane" style={{fontSize: '15px'}} /></span> <span className="font-weight-600" style={{fontSize: '15px'}}>Price includes</span>
            </p>
            <p className="text-danger mb-0" style={{fontSize: '15px', fontWeight: 600, lineHeight: '15px'}}>Round trip flight + taxes and fees</p>
          </div>
          <div className="col-sm-3 text-right d-flex d-sm-block align-items-center">
            <div className="text-success text-3 mb-0 mb-sm-1 order-2 ">0% Off!</div>
            <div className="d-block text-3 text-black-50 mb-0 mb-sm-2 mr-2 mr-sm-0 order-1"><del className="d-block">${props.LowPrice}</del></div>
            <div className="text-dark text-8 font-weight-500 mb-0 mb-sm-2 mr-2 mr-sm-0 order-0">
              <span style={{fontSize: '18px', paddingRight: '3px'}}>$</span>{props.LowPrice}</div>
            <div className="text-black-50 mb-0 mb-sm-2 order-3 d-none d-sm-block">per person<br />hotel + flight</div>
            {/* <a href="booking-hotels-details.html" className="btn btn-sm btn-primary order-4 ml-auto"></a> */}
            <Link className='btn btn-sm btn-primary order-4 ml-auto' to="/HotelDetail" state={props}>Book Now</Link>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}


export default function Hotel() {
  const[hotels, setHotels] = useState([])
  const location = useLocation()
  const [loading, setLoading] = useState(false)

  function searchHotels(){
    setLoading(true)
    if (process.env.NODE_ENV == 'development'){
      axios.get('api/hotels')
      .then(function (res) {
        // console.log('hotel rsp', res)
        // var json = JSON.parse(res.data);
        // setHotels(json.Datas[0].Hotels)

        setHotels(res.data.Datas[0].Hotels.length > 20 ? res.data.Datas[0].Hotels.slice(0,20) : res.data.Datas[0].Hotels)
      })
      .catch(function (error) {
        // console.error(error);
        alert(error)
      }).then(function () {
        setLoading(false);
      });
    }else{
      axios.get('api/hotels'+ location.search)
      .then(function (res) {
        // console.log('hotel rsp', res)
        var json = JSON.parse(res.data);
        // console.log('hote json', json)
        setHotels(json.Datas[0].Hotels.length > 20 ? json.Datas[0].Hotels.slice(0,20) : json.Datas[0].Hotels)
      })
      .catch(function (error) {
        // console.error(error);
        alert(error)
      }).then(function () {
        setLoading(false);
      });

    }

    // let searchParams = {from: 'LAX', checkin: '11/18/2022', checkout: '11/19/2022', rooms: 1, adults: 1, children: 0}

  }

  useEffect(()=>{
    loadCss('css/MVstyle-2022.css');
    loadCss('font-awesome/css/all.min.css');
    loadCss('css/bootstrap.min.css');
    loadCss('css/jquery-ui/jquery-ui.min.css');
    loadCss('Flight-Hotel/vendor/daterangepicker/daterangepicker.css');
    loadCss('css/stylesheet.css');
    loadCss('css/hotel.css');
    // loadCss('Flight-Hotel/vendor/owl.carousel/assets/owl.carousel.min.css');
    loadCss('Flight-Hotel/vendor/owl.carousel/assets/owl.theme.default.min.css');
    
    searchHotels()
  },[])

  return (
    <section className="container">
      {loading && <AppBar position="fixed"><LinearProgress /></AppBar>}
      {/* <h4>{hotels.length}</h4> */}
      {/* <button onClick={handleDemo}>get hotels</button> */}
    <div className="row">
      <div className="col mb-2">
        <form id="bookingHotels" method="post">
          <div className="form-row">
            <div className="col-md-12 col-lg form-group">
              <input type="text" className="form-control" id="hotelsFrom" required placeholder="Enter City / Hotel" />
              <span className="icon-inside"><i className="fas fa-map-marker-alt" /></span> </div>
            <div className="col-md-6 col-lg form-group">
              <input id="hotelsCheckIn" type="text" className="form-control" required placeholder="Check In" />
              <span className="icon-inside"><i className="far fa-calendar-alt" /></span> </div>
            <div className="col-md-6 col-lg form-group">
              <input id="hotelsCheckOut" type="text" className="form-control" required placeholder="Check Out" />
              <span className="icon-inside"><i className="far fa-calendar-alt" /></span> </div>
            <div className="col-md-6 col-lg travellers-class form-group">
              <input type="text" id="hotelsTravellersClass" className="travellers-class-input form-control" name="hotels-travellers-class" placeholder="Rooms / People" required onKeyPress={()=> {return false}} />
              <span className="icon-inside"><i className="fas fa-caret-down" /></span>
              <div className="travellers-dropdown" style={{display: 'none'}}>
                <div className="row align-items-center">
                  <div className="col-sm-7">
                    <p className="mb-sm-0">Rooms</p>
                  </div>
                  <div className="col-sm-5">
                    <div className="qty input-group">
                      <div className="input-group-prepend">
                        <button type="button" className="btn bg-light-4" data-value="decrease" data-target="#hotels-rooms" data-toggle="spinner">-</button>
                      </div>
                      <input type="text" data-ride="spinner" id="hotels-rooms" className="qty-spinner form-control" defaultValue={1} readOnly />
                      <div className="input-group-append">
                        <button type="button" className="btn bg-light-4" data-value="increase" data-target="#hotels-rooms" data-toggle="spinner">+</button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="mt-2 mb-4" />
                <div className="row align-items-center">
                  <div className="col-sm-7">
                    <p className="mb-sm-0">Adults <small className="text-muted">(12+ yrs)</small></p>
                  </div>
                  <div className="col-sm-5">
                    <div className="qty input-group">
                      <div className="input-group-prepend">
                        <button type="button" className="btn bg-light-4" data-value="decrease" data-target="#adult-travellers" data-toggle="spinner">-</button>
                      </div>
                      <input type="text" data-ride="spinner" id="adult-travellers" className="qty-spinner form-control" defaultValue={1} readOnly />
                      <div className="input-group-append">
                        <button type="button" className="btn bg-light-4" data-value="increase" data-target="#adult-travellers" data-toggle="spinner">+</button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="my-2" />
                <div className="row align-items-center">
                  <div className="col-sm-7">
                    <p className="mb-sm-0">Children <small className="text-muted">(1-12 yrs)</small></p>
                  </div>
                  <div className="col-sm-5">
                    <div className="qty input-group">
                      <div className="input-group-prepend">
                        <button type="button" className="btn bg-light-4" data-value="decrease" data-target="#children-travellers" data-toggle="spinner">-</button>
                      </div>
                      <input type="text" data-ride="spinner" id="children-travellers" className="qty-spinner form-control" defaultValue={0} readOnly />
                      <div className="input-group-append">
                        <button type="button" className="btn bg-light-4" data-value="increase" data-target="#children-travellers" data-toggle="spinner">+</button>
                      </div>
                    </div>
                  </div>
                </div>
                <button className="btn btn-primary btn-block submit-done mt-3" type="button">Done</button>
              </div>
            </div>
            <div className="col-md-6 col-lg form-group">
              <button className="btn btn-primary btn-block" type="submit">Search</button>
            </div>
          </div>
        </form>
      </div>
    </div>{/*TOP 搜尋引擎 結束*/}
    {/*  =============================================
=============================================*/}			
    <div className="row">
      {/* 左邊區塊 開始======================= */}
      <aside className="col-lg-3">
        <div className="bg-light shadow-md rounded p-3">
          <div className="theme-search-results-sidebar-map-view">
            <a className="theme-search-results-sidebar-map-view-link" href="#" />
            <div className="theme-search-results-sidebar-map-view-body">
              <i className="fas fa-map-marker-alt theme-search-results-sidebar-map-view-icon" />
              <p className="theme-search-results-sidebar-map-view-sign">Map View</p>
            </div>
            <div className="theme-search-results-sidebar-map-view-mask" />
          </div>
          <h3 className="text-5">Filter</h3>
          <div className="accordion accordion-alternate style-2" id="toggleAlternate">
            <div className="card">
              <div className="card-header" id="hotelName">
                <h5 className="mb-0"> <a href="#" className="collapse collapsed" data-toggle="collapse" data-target="#togglehotelName" aria-expanded="false" aria-controls="togglehotelName">Hotel Name</a> </h5>
              </div>
              <div id="togglehotelName" className="collapse" aria-labelledby="hotelName" style={{}}>
                <div className="card-body">
                  <div className="form-row">
                    <div className="col-md-12 col-lg form-group mb-0">
                      <input type="text" className="form-control form-control-sm" id="SearchHotel" placeholder="Search by Hotel Name" />
                      <span className="icon-inside"><i className="fas fa-search" /></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="propertyTypes">
                <h5 className="mb-0"> <a href="#" className="collapse" data-toggle="collapse" data-target="#togglepropertyTypes" aria-expanded="true" aria-controls="togglepropertyTypes">Property Types</a> </h5>
              </div>
              <div id="togglepropertyTypes" className="collapse show" aria-labelledby="propertyTypes">
                <div className="card-body">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="hotel" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="hotel">Hotel <small className="text-muted float-right">250</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="resort" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="resort">Resort <small className="text-muted float-right">76</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="villa" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="villa">Villa <small className="text-muted float-right">31</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="heritage" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="heritage">Heritage <small className="text-muted float-right">12</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="motel" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="motel">Motel <small className="text-muted float-right">5</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="guestHouse" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="guestHouse">Guest House <small className="text-muted float-right">107</small></label></div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="farmHouse" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="farmHouse">Farm House <small className="text-muted float-right">66</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="palace" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="palace">Palace <small className="text-muted float-right">18</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="sercicedApartments" name="propertyTypes" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="sercicedApartments">Serviced Apartments <small className="text-muted float-right">41</small></label>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="starCategory">
                <h5 className="mb-0"> <a href="#" className="collapse" data-toggle="collapse" data-target="#togglestarCategory" aria-expanded="true" aria-controls="togglestarCategory">Star Category</a> </h5>
              </div>
              <div id="togglestarCategory" className="collapse show" aria-labelledby="starCategory">
                <div className="card-body">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="5Star" name="starCategory" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="5Star">5 Star <i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /> <small className="text-muted float-right">512</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="4Star" name="starCategory" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="4Star">4 Star <i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /><small className="text-muted float-right">476</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="3Star" name="starCategory" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="3Star">3 Star <i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /> <small className="text-muted float-right">176</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="2Star" name="starCategory" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="2Star">2 Star <i className="fas fa-star text-warning" /><i className="fas fa-star text-warning" /> <small className="text-muted float-right">231</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="1Star" name="starCategory" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="1Star">1 Star <i className="fas fa-star text-warning" /> <small className="text-muted float-right">5</small></label>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="userReview">
                <h5 className="mb-0"> <a href="#" className="collapse" data-toggle="collapse" data-target="#toggleuserReview" aria-expanded="true" aria-controls="toggleuserReview">User Review</a> </h5>
              </div>
              <div id="toggleuserReview" className="collapse show" aria-labelledby="userReview">
                <div className="card-body">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="excellent" name="userReview" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="excellent">Excellent <small className="text-muted float-right">499</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="good" name="userReview" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="good">Good <small className="text-muted float-right">310</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="fair" name="userReview" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="fair">Fair <small className="text-muted float-right">225</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="poor" name="userReview" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="poor">Poor <small className="text-muted float-right">110</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="bad" name="userReview" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="bad">Bad <small className="text-muted float-right">44</small></label>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="amenities">
                <h5 className="mb-0"> <a href="#" className="collapse" data-toggle="collapse" data-target="#toggleamenities" aria-expanded="true" aria-controls="toggleamenities">Amenities</a> </h5>
              </div>
              <div id="toggleamenities" className="collapse show" aria-labelledby="amenities">
                <div className="card-body">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="internetWiFi" name="amenities" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="internetWiFi"><i className="fas fa-wifi" /> Internet/Wi-Fi <small className="text-muted float-right">512</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="restaurant" name="amenities" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="restaurant"><i className="fas fa-utensils" /> Restaurant <small className="text-muted float-right">476</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="bar" name="amenities" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="bar"><i className="fas fa-glass-martini" /> Bar <small className="text-muted float-right">176</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="swimmingPool" name="amenities" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="swimmingPool"><i className="fas fa-swimmer" /> Swimming Pool <small className="text-muted float-right">231</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="businessFacilities" name="amenities" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="businessFacilities"><i className="fas fa-chalkboard-teacher" /> Business Facilities <small className="text-muted float-right">5</small></label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="spaWellness" name="amenities" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="spaWellness"><i className="fas fa-spa" /> Spa/Wellness <small className="text-muted float-right">107</small></label>                    </div>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="gym" name="amenities" className="custom-control-input" />
                    <label className="custom-control-label d-block" htmlFor="gym"><i className="fas fa-dumbbell" /> Gym <small className="text-muted float-right">66</small></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>{/* 左邊區塊 結束======================= */}
      {/*  =============================================
=============================================*/}				
      <div className="col-lg-9 mt-4 mt-lg-0">
        {/* 右邊 飯店區塊
============================================= */}
        {/*搜尋結果 + 價格排序*/}	
        <div className="border-bottom mb-3 pb-3">
          <div className="row align-items-center">
            <div className="col-6 col-md-8">
              <span className="mr-3"><span className="text-4">Ahmedabad:</span> <span className="font-weight-600">{hotels.length} Hotels</span> found</span> <span className="text-warning text-nowrap">Prices inclusive of taxes</span></div>
            <div className="col-6 col-md-4">
              <div className="row no-gutters ml-auto">
                <label className="col col-form-label-sm text-right mr-2 mb-0" htmlFor="input-sort">Sort By:</label>
                <select id="input-sort" className="custom-select custom-select-sm col" defaultValue={"POP"}>
                  <option value="POP">Popularity</option>
                  <option value="PLTH">Price - Low to High</option>
                  <option value="PHTL">Price - High to Low</option>
                  <option value="UHTL">User Rating - High to Low</option>
                </select>
              </div>
            </div>
          </div>
        </div>{/* 搜尋結果 + 價格排序 end */}
        {/* ============================================
                   List Item
============================================= */}
        <div className="hotels-list">
          {/*item 開始 */}
          {hotels.map((item)=>{return <HotelItem key={item.GTTHotelID} {...item}/>})}
          {/*item 結束*/}
        </div>{/* List Item end */}
        {/* Pagination 頁 碼 區 塊
        ============================================= */}  
        <ul className="pagination justify-content-center mt-4 mb-0">
          <li className="page-item disabled"> <a className="page-link" href="#" tabIndex={-1}><i className="fas fa-angle-left" /></a> </li>
          <li className="page-item"><a className="page-link" href="#">1</a></li>
          <li className="page-item active"> <a className="page-link" href="#">2 <span className="sr-only">(current)</span></a> </li>
          <li className="page-item"><a className="page-link" href="#">3</a></li>
          <li className="page-item"> <a className="page-link" href="#"><i className="fas fa-angle-right" /></a> </li>
        </ul>{/* Paginations 頁 碼 區 塊 end */}
      </div>
    </div>
  </section>
  )
}
